"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const reportsActions = [
    {
        name: 'reports.cost_report',
        path: ['/cost-report'],
        method: 'GET',
    },
    {
        name: 'reports.usage_cost_stats',
        path: ['/usage-cost/stats'],
        method: 'GET',
    },
    {
        name: 'reports.user_summary_stats',
        path: ['/user-summary/stats'],
        method: 'GET',
    },
    {
        name: 'reports.avatar_usage_stats',
        path: ['/avatar-usage/stats'],
        method: 'GET',
    },
    {
        name: 'reports.export_usage_cost',
        path: ['/usage-cost/export'],
        method: 'GET',
    },
    {
        name: 'reports.shared_conversations',
        path: ['/shared-conversations'],
        method: 'GET',
    },
    {
        name: 'reports.get-data',
        path: ['/usage-info/:id'],
        method: 'GET'
    },
];
exports.default = reportsActions;
